import styled from "styled-components";

export const HeaderDescription = styled.div`
	${({ theme }) => theme.textStyles.headersDescription}
`;

export const Description = styled.div`
	${({ theme }) => theme.textStyles.primary}
`;

export const Subdescription = styled.div`
	${({ theme }) => theme.textStyles.subdescription}
`;
export const Smalldescription = styled.div`
	${({ theme }) => theme.textStyles.smalldescription}
`;
